<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="20" height="20" rx="4" fill="#FFA100"/>
  <path d="M5.5 10.5L8.5 13.5L14.5 6.5" stroke="#04051B" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
